import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger'

function ReduxProvider({ children, reducers, middlewares }) {
  console.log('reduxProvider', reducers, middlewares)
  const store = createStore(reducers, applyMiddleware(thunk, logger, ...middlewares))
  return (
    <Provider store={store}>
      {children}
    </Provider>
  )
}

ReduxProvider.defaultProps = {
  middlewares: [],
}

ReduxProvider.propTypes = {
  children: PropTypes.node.isRequired,
  reducers: PropTypes.objectOf(PropTypes.any).isRequired,
  middlewares: PropTypes.arrayOf(PropTypes.object),
}

export default ReduxProvider
